import { Box } from '@chakra-ui/react';

export default function RecordingIndicator({ size = '16px' }: { size?: string }) {
  return (
    <Box
      w={size}
      h={size}
      borderRadius="50%"
      bg="error.700"
      animation="pulse 1s infinite"
      position="relative"
      role="status"
      aria-label="Recording in progress"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '50%',
        border: '2px solid',
        borderColor: 'error.700',
        animation: 'pulse 1s infinite',
        opacity: 0,
        transform: 'scale(1.5)'
      }}
    />
  );
}
